<template>
  <section id="Landing">
    <div id="LandingAnchor" />
    <div class="repnav">
      <div class="repbar">
        <div class="repBox">
          <div class="rep-title">Your Account Representative</div>
          <div class="rep-info">{{ global.userInfo.repName }}</div>
          <div class="rep-info">
            <a :href="'mailto:' + global.userInfo.repEmail">{{ global.userInfo.repEmail }}</a> <span>/</span> {{ global.userInfo.repPhone }}
          </div>
        </div>
      </div>
    </div>
    <div class="top">
      <b-container>
        <div class="info not-beyond">
          <div class="welcome-text-cnt">
            <p>{{ global.userInfo.fullName }},<span>Welcome to your</span></p>
          </div>
          <div class="ptp-cnt">
            <p>United Club<span>Seat Extension</span></p>
          </div>
          <div class="renewal-deadline">
            <p>Extend your united club seats by<span>Oct 21, 2025</span></p>
          </div>
          <Countdown />
          <!-- <div class="landing-button-cnt">
            <div class="landing-btn" v-b-modal.expiringModal><p>Extend Now</p></div>
          </div> -->
          <div class="no-payment">No Payment Is Due Until 2026</div>
        </div>
      </b-container>
    </div>
    <b-modal id="expiringModal" hide-header hide-footer>
      <div
        class="close fancybox-close"
        @click="$bvModal.hide('expiringModal')"
      />
      <ExtensionPopup />
    </b-modal>
    <b-modal id="policiesModal" hide-header hide-footer>
      <div
        class="close fancybox-close"
        @click="$bvModal.hide('policiesModal')"
      />
      <PoliciesPopup />
    </b-modal>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Countdown from "@/components/global/Countdown";
import ExtensionPopup from "@/components/global/ExtensionPopup";
import PoliciesPopup from "@/components/global/PoliciesPopup";

export default {
  name: "Landing",
  components: {
    Countdown,
    ExtensionPopup,
    PoliciesPopup
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState(["global"])
  },
}
</script>

<style lang="scss" scoped>
#Landing {
  position: relative;
  background: url('~@/assets/bg/bg-landing-texture.png') scroll no-repeat top right #FF4B00;
  background-size: 800px 100%;
  height: 636px;
  &:before {
    position: absolute;
    content: '';
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    width: 1600px;
    height: 636px;
    background: url('~@/assets/bg/bg-landing-players.png') scroll no-repeat bottom right;
    background-size: 1600px 100%;
    @media only screen and (max-width: 1599px) {
      right: -200px;
    }
    @media only screen and (max-width: 1200px) {
      zoom: 90%;
      zoom: 0.9;
      -ms-zoom: 0.9;
    }
    @media only screen and (max-width: 1052px) {
      display: none;
    }
  }
  #LandingAnchor {
    position: absolute;
    top: 0;
    left: 0;
  }
  .repnav {
    z-index: 8;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    .repbar {
      z-index: 3;
      position: absolute;
      display: flex;
      padding: 22px 30px;
      top: 40px;
      right: 0;
      width: 343px;
      height: 95px;
      background: url('~@/assets/bg/pif-bg.png') scroll no-repeat center center;
      background-size: 343px 95px;
      .repBox {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        .rep-title {
          margin-bottom: 5px;
          font-size: 11px;
          @include nofex;
          line-height: 12px;
          letter-spacing: 1.1px;
          text-transform: uppercase;
          color: $blue;
        }
        .rep-info {
          font-size: 10px;
          @include nexaBold;
          line-height: 15px;
          color: $blue;
          a {
            text-decoration: none;
            color: $blue;
          }
          span {
            margin: 0 5px;
          }
        }
      }
    }
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
  div.home-pif-box {
    z-index: 3;
    position: absolute;
    top: 40px;
    right: 0;
    width: 343px;
    height: 95px;
    background: url('~@/assets/bg/pif-bg.png') scroll no-repeat center center;
    background-size: 343px 95px;
    .pifBox {
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 32px;
      .pif-img {
        display: inline-flex;
        margin-right: 8px;
        img {
          width: 28px;
        }
      }
      .pif-text {
        width: 100%;
        max-width: 228px;
        font-size: 12px;
        @include nexaBold;
        line-height: 15px;
        text-align: left;
        color: $dark-blue;
      }
    }
  }
  .top {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    .container {
      max-width: 1040px;
    }
    .info {
      position: relative;
      display: inline-block;
      width: 100%;
      max-width: 575px;
      .welcome-text-cnt {
        margin-bottom: 20px;
        p {
          font-size: 62px;
          @include nexaBold;
          line-height: 1;
          text-transform: uppercase;
          color: $white;
          span {
            display: block;
            font-size: 28px;
            line-height: 1;
          }
        }
      }
      .ptp-cnt {
        margin-bottom: 20px;
        p {
          font-size: 42px;
          @include nofex;
          line-height: 36px;
          text-transform: uppercase;
          color: #092244;
          span {
            display: block;
          }
        }
      }
      .renewal-deadline {
        margin-bottom: 20px;
        p {
          font-size: 15px;
          @include nexaBold;
          line-height: 22px;
          text-transform: uppercase;
          color: $white;
          span {
            display: block;
            font-size: 21px;
          }
        }
      }
      .landing-button-cnt {
        margin-top: 20px;
        .landing-btn {
          cursor: pointer;
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 10px 20px;
          text-decoration: none;
          font-size: 13px;
          @include nexaBold;
          line-height: 18px;
          text-align: center;
          text-transform: uppercase;
          width: 178px;
          height: 33px;
          background: url("~@/assets/bg/white-btn-bg.png") scroll no-repeat center center;
          background-size: 178px 33px;
          color: $dark-blue;
        }
      }
      .no-payment {
        margin-top: 35px;
        font-size: 26px;
        @include nexaBold;
        line-height: 1;
        text-transform: uppercase;
        color: #FFF;
      }
    }
  }
}
</style>

<style lang="scss">
#expiringModal, #beyondModal, #policiesModal {
  padding-left: 0 !important;
  .modal {
    padding: 0;
  }
  .modal-dialog {
    width: 100vw;
    max-width: 100vw;
    margin: 0;
  }
  .modal-content {
    width: 100vw;
    background-color: transparent;
    border: none;
    overflow: auto;
    padding: 30px 20px;
    height: calc(100vh);
  }
  .modal-body {
    align-items: center;
    padding: 0;
    // width: fit-content;
    width: 100%;
    max-width: 940px;
    margin: auto;
    // padding: 0 20px;
  }
  .close {
    position: absolute;
    top: 6px;
    right: 15px;
    height: 36px;
    width: 36px;
    opacity: 1;
    cursor: pointer;
    z-index: 999;
    &.fancybox-close {
      background-image: url("~@/assets/icons/fancybox_sprite.png");
    }
    @media (max-width: $md) {
      top: 7px;
      right: 27px;
    }
  }
}
</style>